module.exports = __webpack_public_path__ + "static/stone-7e00da5dd1516aeace6474b66b487121.gif";